export type VideoRatio = '16:9' | '9:16' | '1:1'

export interface DemoVideo {
  id: string
  title: string
  type: string
  context: string
  duration: string
  src: string
  poster: string
  ratio: VideoRatio
  sourcePage: string
  licensePage: string
}

const base = '/videos/demo'
const mixkitLicense = 'https://mixkit.co/license/#videoFree'

export const demoVideos: DemoVideo[] = [
  {
    id: 'hero-city',
    title: '城市品牌影像',
    type: '横屏创意视频',
    context: '首页品牌主视觉',
    duration: '00:31',
    src: `${base}/hero-city.mp4`,
    poster: `${base}/posters/hero-city.jpg`,
    ratio: '16:9',
    sourcePage: 'https://mixkit.co/free-stock-video/aerial-view-above-the-skyscrapers-of-a-city-41539/',
    licensePage: mixkitLicense,
  },
  {
    id: 'creative-rider',
    title: '光影人物短片',
    type: 'AI 视频视觉参考',
    context: '创意视频案例',
    duration: '00:07',
    src: `${base}/creative-rider.mp4`,
    poster: `${base}/posters/creative-rider.jpg`,
    ratio: '16:9',
    sourcePage: 'https://mixkit.co/free-stock-video/a-focused-woman-driving-a-motorcycle-through-colorful-lighting-in-99862/',
    licensePage: mixkitLicense,
  },
  {
    id: 'enterprise-robot',
    title: '智能制造企业短片',
    type: '企业宣传',
    context: '工业与企业案例',
    duration: '00:16',
    src: `${base}/enterprise-robot.mp4`,
    poster: `${base}/posters/enterprise-robot.jpg`,
    ratio: '16:9',
    sourcePage: 'https://mixkit.co/free-stock-video/robot-working-in-a-production-line-47257/',
    licensePage: mixkitLicense,
  },
  {
    id: 'product-skincare',
    title: '护肤产品演示',
    type: '产品介绍视频',
    context: '消费品内容案例',
    duration: '00:12',
    src: `${base}/product-skincare.mp4`,
    poster: `${base}/posters/product-skincare.jpg`,
    ratio: '16:9',
    sourcePage: 'https://mixkit.co/free-stock-video/a-woman-opens-a-moisturizing-skincare-product-to-apply-it-50415/',
    licensePage: mixkitLicense,
  },
  {
    id: 'product-studio',
    title: '商品视频拍摄实操',
    type: '课程试看',
    context: '培训课程片段',
    duration: '00:17',
    src: `${base}/product-studio.mp4`,
    poster: `${base}/posters/product-studio.jpg`,
    ratio: '16:9',
    sourcePage: 'https://mixkit.co/free-stock-video/woman-taking-product-photos-on-a-set-44122/',
    licensePage: mixkitLicense,
  },
  {
    id: 'course-presentation',
    title: '品牌内容拆解课',
    type: '培训课程',
    context: '讲师与团队演示',
    duration: '00:09',
    src: `${base}/course-presentation.mp4`,
    poster: `${base}/posters/course-presentation.jpg`,
    ratio: '16:9',
    sourcePage: 'https://mixkit.co/free-stock-video/presentation-during-a-work-team-meeting-42666/',
    licensePage: mixkitLicense,
  },
  {
    id: 'vertical-urban',
    title: '竖屏人物短片',
    type: '人物营销视频',
    context: '9:16 短视频流',
    duration: '00:13',
    src: `${base}/vertical-urban.mp4`,
    poster: `${base}/posters/vertical-urban.jpg`,
    ratio: '9:16',
    sourcePage: 'https://mixkit.co/free-stock-video/urban-trendy-girl-walking-to-the-camera-1227/',
    licensePage: mixkitLicense,
  },
  {
    id: 'vertical-beauty',
    title: '竖屏美妆营销',
    type: '短视频营销',
    context: '9:16 商品口播场景',
    duration: '00:15',
    src: `${base}/vertical-beauty.mp4`,
    poster: `${base}/posters/vertical-beauty.jpg`,
    ratio: '9:16',
    sourcePage: 'https://mixkit.co/free-stock-video/vertical-video-of-a-young-woman-placing-golden-eye-bag-51184/',
    licensePage: mixkitLicense,
  },
  {
    id: 'square-product-studio',
    title: '方形商品制作片段',
    type: '1:1 视频卡片',
    context: '方形内容流',
    duration: '00:10',
    src: `${base}/square-product-studio.mp4`,
    poster: `${base}/posters/square-product-studio.jpg`,
    ratio: '1:1',
    sourcePage: 'https://mixkit.co/free-stock-video/woman-taking-product-photos-on-a-set-44122/',
    licensePage: mixkitLicense,
  },
]

export const heroVideo = demoVideos[0]
export const featuredVideos = demoVideos.slice(1, 5)
export const courseVideos = [demoVideos[5], demoVideos[4]]
export const verticalVideos = [demoVideos[6], demoVideos[8], demoVideos[7]]
